.baseSelect {
  all: unset;
  border: 1px solid black;
  border-radius: 4px;
  margin-top: 2px;
  margin-bottom: 2px;
  padding: 1px 20px 1px 6px;
  min-width: 40px;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="black" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 50%;
}
